/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { LogoWrapper, Typography2, breakpoints } from '@coursera/cds-core';

import type { EnterpriseCourseFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageQuery';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  container: css`
    ${breakpoints.down('xs')} {
      padding: var(--cds-spacing-200);
    }
  `,
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  imageContainer: css`
    display: flex;
    flex-wrap: wrap;
    gap: var(--cds-spacing-300);
    align-items: center;
    justify-content: center;
  `,
  partnerImage: css`
    object-fit: contain;
  `,
};

type Partner = EnterpriseCourseFieldsFragment['partners'][0];

type Props = {
  partners: Partner[];
};

const SkillPathwaySidebarContent = ({ partners }: Props) => {
  if (!partners?.length) {
    return null;
  }

  return (
    <div css={styles.container}>
      <Typography2 variant="subtitleLarge" component="h3" css={styles.title}>
        {_t('Brought to you by')}
      </Typography2>
      <LogoWrapper paddingVariant="small">
        <div css={styles.imageContainer}>
          {partners.map((partner) => {
            if (!partner.logo) {
              return null;
            }

            return (
              <Imgix
                key={partner.name}
                src={partner.logo}
                alt={partner.name}
                maxWidth={90}
                maxHeight={35}
                css={styles.partnerImage}
              />
            );
          })}
        </div>
      </LogoWrapper>
    </div>
  );
};

export default SkillPathwaySidebarContent;
